import { Post } from "store/campaigns/campaignPosts/campaignPosts.types";
import * as S from "./index.styles";

interface PostItemProps {
  post: Post;
  onPostClick: (postId: Post["id"]) => void;
}

const RelatedPostItem: React.FC<PostItemProps> = ({ post, onPostClick }) => {
  return (
    <S.PostContainer key={post.id} onClick={()=>onPostClick(post.id)}>
      {post.image_url && (
        <S.PostImage
          src={post.image_url}
          alt={post.post_caption || `Post ${post.id}`}
        />
      )}
    </S.PostContainer>
  );
};

export default RelatedPostItem;